<template>
  <v-layout
    row wrap
    align-center
    :style="isEnabled(userData.isEnabled)"
    class="strategio-user-list-item"
    @click="adminUser(userData.userID)"
  >
    <v-flex xs12 sm12 md2 lg2 xl2>
      <v-layout justify-center>
        <v-chip
          small
          class="ml-0"
          :color="pickColor(userData.userType)"
          :style="[
            {'color': 'white'},
            {'width': getChipWidth()},
            {'justify-content': 'center'}
          ]"
        >{{userData.userType}}</v-chip>

      </v-layout>
    </v-flex>

    <v-flex xs12 sm12 md3 lg3 xl3>
      <img height="31px" :src="require('@/assets/manage-users-icons/user.png')" alt="user-icon">
      <strong>{{userData.isEnabled ? "" : "[Deshabilitado] "}}{{userData.name}}</strong>
    </v-flex>

    <v-flex xs12 sm12 md7 lg7 xl7 py-0 my-2>
      <v-layout row wrap>
        <v-flex xs12 sm6 py-0 my-2>
          <v-layout row wrap align-end>
            <v-flex xs12 md2 py-0>
              <img height="31px" :src="require('@/assets/manage-users-icons/position.png')" alt="user-icon">
            </v-flex>
            <v-flex xs12 md10 py-0 pb-1>
              <strong>{{userData.description}}</strong>
            </v-flex>
          </v-layout>

        </v-flex>
        <v-flex xs12 sm6 py-0 my-2>
          <v-layout row wrap align-end>
            <v-flex xs12 md2 py-0>
              <img height="30px" :src="require('@/assets/manage-users-icons/email.png')" alt="user-icon">
            </v-flex>
            <v-flex xs12 md10 py-0 pb-1>
              <span class="grey--text" ellipsis>{{userData.mail}}</span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

  </v-layout>

</template>

<script>

export default {
  name: 'users-list-item',
  props: ['userData'],
  methods: {
    isEnabled (isEnabled) {
      return 'opacity: ' + (isEnabled ? '1' : '0.5')
    },
    getChipWidth () {
      let widthio = ''
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          widthio = '70%'
          break
        case 'md':
        case 'lg':
        case 'xl':
          widthio = '150px'
          break
        default:
          // widthio = ''
          break
      }

      return widthio
    },
    pickColor (userType) {
      switch (userType) {
        case 'ADMIN': return 'blue darken-1'
        case 'SUPERVISOR': return 'amber darken-1'
        case 'GLOBAL': return 'light-green darken-1'
        case 'NORMAL': return 'cyan darken-1'
        case 'DEMO': return 'purple darken-1'
        default: return 'grey darken-1'
      }
    },
    adminUser (userID) {
      this.$router.push(`/user/admin/${userID}`)
    }
  }
}
</script>

<style>
.strategio-user-list-item {
  padding: 12px 16px 12px 16px !important;
  cursor: pointer;
}
.strategio-user-list-item:hover {
  background-color: rgb(224, 224, 224);
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/users/users-list-item.vue